import {AfterViewInit, Component, OnInit} from '@angular/core';
import {AuthenticationService} from '../../../core/services/authentication.service';

@Component({
  selector: 'app-error-not-found',
  templateUrl: './error-not-found.component.html',
  styleUrls: ['./error-not-found.component.scss']
})
export class ErrorNotFoundComponent implements OnInit, AfterViewInit {
  path: string;

  constructor(private authService: AuthenticationService) {
  }

  ngOnInit() {
    this.path = '/login';
  }

  ngAfterViewInit(): void {
    // this.authService.logout();
  }

}
